import React, { useState } from "react";
import { DB } from "../../firebase";
import { useDispatch } from "react-redux";
import { getArticleList } from "../../actions";

const AddNewArticleBtn = () => {
  const dispatch = useDispatch();
  const [loading, setLoading] = useState(false);

  const addArticle = () => {
    setLoading(true);
    DB.collection("articles")
      .add({
        description: "",
        title: "Nowy Artykuł",
      })
      .then(() => dispatch(getArticleList()))
      .then(() => setLoading(false));
  };
  return (
    <div className="mt-4">
      <button
        disabled={loading}
        className="btn btn-primary btn-sm btn-block"
        onClick={addArticle}
      >
        {loading ? "Dodaję artykuł, proszę czekać...." : "Dodaj artykuł"}
      </button>
    </div>
  );
};

export default AddNewArticleBtn;



// WEBPACK FOOTER //
// ./src/screens/ManageArticle/AddNewArticleBtn.js